import Loading from './Loading'

export default Loading
// eslint-disable-next-line import/export
export * from './Loading'
